import { SEOBlogPosting } from '../../types'

export interface SEOGetBlogPostingInput {
  canonicalUrl: string
  title: string
  description: string
  datePublished: string
  dateModified: string
  author: {
    name: string
    url: string
    description?: string
  }
  articleBody: string
  publisherId: string
  image?: {
    url: string
    width: number
    height: number
  }
}

const DEFAULT_IMAGE = {
  url: 'https://static.jusbr.com/images/logo/logo-jusbrasil-1200-675.png',
  width: 1200,
  height: 675,
}

export const getBlogPosting = ({
  canonicalUrl,
  title,
  description,
  datePublished,
  dateModified,
  author,
  articleBody,
  publisherId,
  image = DEFAULT_IMAGE,
}: SEOGetBlogPostingInput): SEOBlogPosting => ({
  '@type': 'BlogPosting',
  '@id': canonicalUrl,
  url: canonicalUrl,
  headline: title,
  name: title,
  description,
  image: {
    '@type': 'ImageObject',
    url: image.url,
    width: image.width,
    height: image.height,
  },
  datePublished,
  dateModified,
  author: {
    '@type': 'Person',
    name: author.name,
    url: author.url,
    ...(author.description ? { description: author.description } : {}),
  },
  articleBody,
  publisher: {
    '@id': publisherId,
  },
})
